import { call, put, takeLatest } from 'redux-saga/effects';
import { message as andMessage } from 'antd';
import {
  getCurrentMegaphoneBanner, invalidateCacheMegaphoneBanner, postMegaphoneBanner, putCurrentMegaphoneBanner,
} from '../../services/megaphoneBanner';
import {
  REQUEST_MEGAPHONE_BANNER,
  REQUEST_MEGAPHONE_BANNER_FAIL,
  REQUEST_MEGAPHONE_BANNER_SUCCESS,
  UPDATE_MEGAPHONE_BANNER,
  UPDATE_MEGAPHONE_BANNER_FAIL,
  UPDATE_MEGAPHONE_BANNER_SUCCESS,
  CREATE_MEGAPHONE_BANNER,
  CREATE_MEGAPHONE_BANNER_FAIL,
  CREATE_MEGAPHONE_BANNER_SUCCESS,
} from '../actionTypes';

function* fetchCurrentMegaphoneBanner(action) {
  try {
    const data = yield call(getCurrentMegaphoneBanner);
    yield put({ type: REQUEST_MEGAPHONE_BANNER_SUCCESS, payload: { data } });
  } catch (errorResponse) {
    const message = errorResponse.message || (yield errorResponse.json()).message;

    andMessage.error(message);
    yield put({ type: REQUEST_MEGAPHONE_BANNER_FAIL, payload: message });
  }
}

function* updateCurrentMegaphoneBanner({ payload: { id, data } }) {
  try {
    const newData = yield call(putCurrentMegaphoneBanner, id, data);
    yield put({ type: UPDATE_MEGAPHONE_BANNER_SUCCESS, payload: { id, data: newData } });
    andMessage.success('Megaphone Banner was updated satisfactorily');
    yield call(invalidateCacheMegaphoneBanner);
  } catch (errorResponse) {
    const message = errorResponse.message || (yield errorResponse.json()).message;

    andMessage.error(message);
    yield put({ type: UPDATE_MEGAPHONE_BANNER_FAIL, payload: message });
  }
}

function* createMegaphoneBanner({ payload: data }) {
  try {
    const createdData = yield call(postMegaphoneBanner, data);
    yield put({ type: CREATE_MEGAPHONE_BANNER_SUCCESS, payload: createdData });
    andMessage.success('Megaphone Banner was created satisfactorily');
    yield call(invalidateCacheMegaphoneBanner);
  } catch (errorResponse) {
    const message = errorResponse.message || (yield errorResponse.json()).message;

    andMessage.error(message);
    yield put({ type: CREATE_MEGAPHONE_BANNER_FAIL, payload: message });
  }
}

function* megaphoneBannerSaga() {
  yield takeLatest(REQUEST_MEGAPHONE_BANNER, fetchCurrentMegaphoneBanner);
  yield takeLatest(UPDATE_MEGAPHONE_BANNER, updateCurrentMegaphoneBanner);
  yield takeLatest(CREATE_MEGAPHONE_BANNER, createMegaphoneBanner);
}

export default megaphoneBannerSaga;
